import Providers from 'context'
import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import Routes from 'routes'
import { GlobalStyles } from 'styles/global'

const App = () => {
  console.log('janio', process.env.NODE_ENV)
  return (
    <>
      <BrowserRouter>
        <GlobalStyles />
        <Providers>
          <Routes />
        </Providers>
      </BrowserRouter>
    </>
  )
}

export default App
